import React, { Fragment } from 'react'
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material'
import { X } from 'react-feather'

import { ModalForm } from './ModalDeposit/ModalForm'
import { RetroactiveTransaction } from './RetroactiveTransaction'



export const ModalModule = ({ useFetchInit}) => {
    const { dataModal, toggle } = useFetchInit
    const { open, titleModal, componentModal, dataRequest } = dataModal
    const { message1, message2, message3 } = dataRequest || {}

    return (
        <Fragment>
            <Dialog
                open={open}
                onClose={toggle}
                fullWidth
                maxWidth='md'
                aria-labelledby='customized-dialog-title'
                tabIndex={-1}
            >
                <DialogTitle id='customized-dialog-title' sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    {titleModal}
                    <p>{message1} {message2} {message3}</p>
                    <IconButton aria-label='close' onClick={toggle}>
                        <X />
                    </IconButton>
                </DialogTitle>
                <DialogContent>

                    {componentModal === 'deposits-section' && (
                        <ModalForm useFetchInit={useFetchInit} dataModal={dataModal} />
                    )}
                    
                    {componentModal === 'RetroactiveTransaction' && (
                        <RetroactiveTransaction useFetchInit={useFetchInit} dataModal={dataModal} />
                    )}
                </DialogContent>
            </Dialog>
        </Fragment>
    )

}